import React from "react"

import {
  Wrapper,
  Title,
  UnorderedList,
  UnorderedListItem,
  OrderedList,
  OrderedListItem,
} from "./styles"

const List = ({ element }) => {
  const { listType, anchor, priority, title, items } = element

  switch (listType) {
    case "unordered":
      return (
        <Wrapper>
          {title && <Title priority={priority}>{title}</Title>}
          <UnorderedList id={`mbg-${anchor}`}>
            {items.map((item, idx) => (
              <UnorderedListItem
                key={`list-item-${anchor}-${idx}`}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            ))}
          </UnorderedList>
        </Wrapper>
      )
    case "ordered":
      return (
        <Wrapper>
          {title && <Title priority={priority}>{title}</Title>}
          <OrderedList id={`mbg-${anchor}`}>
            {items.map((item, idx) => (
              <OrderedListItem
                key={`list-item-${anchor}-${idx}`}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            ))}
          </OrderedList>
        </Wrapper>
      )
    default:
      return null
  }
}

export default List
